var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"atom-chip"},[_c('v-chip',{staticClass:"atom-chip",attrs:{"label":"","small":"","outlined":"","color":_vm.props.color}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }